import { useEffect } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { LoginScreen } from './components/LoginScreen';
import { ChatScreen } from './components/ChatScreen';
import { ToastProvider } from './components/ui/Toast';
import { loadThemePreference, applyThemePreference } from './state/theme';

export function App() {
  useEffect(() => {
    applyThemePreference(loadThemePreference());
  }, []);
  // Sidebar-redesign layout: ChatScreen owns the whole shell —
  // <div class="shell"><Sidebar /><main class="shell-main">…</main></div>.
  // The pre-redesign Splitter (empty left pane + chat on the right) is gone.
  return (
    <ToastProvider>
      <UnauthenticatedTemplate>
        <LoginScreen />
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <ChatScreen />
      </AuthenticatedTemplate>
    </ToastProvider>
  );
}
